import script from "./app-message.vue?vue&type=script&lang=ts&setup=true"
export * from "./app-message.vue?vue&type=script&lang=ts&setup=true"

import "./app-message.vue?vue&type=style&index=0&id=26b02806&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26b02806"]])

export default __exports__